import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-validar',
  templateUrl: 'validar.html',
})
export class ValidarPage {
  numOrden;
  user;
  mPago;
  language = {};
  banco;
  sucursal;
  recibo;
  fecha;
  hora;
  monto;
  envio;
  remitente;
  destinatario;
  agente;
  cliente;
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.user = JSON.parse(localStorage.getItem("user"));
    this.http.get("https://ebenlovequickpc.com/API/factura.php?cl=select&usuario="+this.user.CODIGO_USER).subscribe((data)=>{
          this.numOrden = data.json()[0].CODIGO_FACTURA;
        })
  }

  ionViewDidLoad() {
  }

  compEnvio(){
    if(this.mPago == 'Banco'){
      this.http.get("https://ebenlovequickpc.com/API/confirmacion.php?cl=banco&recibo="+this.recibo+"&banco="+this.banco+"&sucursal="+this.sucursal+"&monto="+this.monto+"&fecha="+this.fecha+"&hora="+this.hora+"&orden="+this.numOrden+"&user="+this.user.CODIGO_USER).subscribe((data)=>{
        this.navCtrl.pop();
        })
    }else if(this.mPago == 'Envios'){
      this.http.get("https://ebenlovequickpc.com/API/confirmacion.php?cl=envios&recibo="+this.recibo+"&envio="+this.envio+"&remitente="+this.remitente+"&monto="+this.monto+"&fecha="+this.fecha+"&hora="+this.hora+"&destinatario="+this.destinatario+"&orden="+this.numOrden+"&user="+this.user.CODIGO_USER).subscribe((data)=>{
        console.log(data)
      this.navCtrl.pop();
      })
    }else if(this.mPago == 'AgenteQuickPC'){
      this.http.get("https://ebenlovequickpc.com/API/confirmacion.php?cl=agente&recibo="+this.recibo+"&agente="+this.agente+"&cliente="+this.cliente+"&monto="+this.monto+"&fecha="+this.fecha+"&hora="+this.hora+"&orden="+this.numOrden+"&user="+this.user.CODIGO_USER).subscribe((data)=>{
        this.navCtrl.pop();
      })
    }

  }

}


// WEBPACK FOOTER //
// ./src/pages/validar/validar.ts